import { render } from "./AktuellesNew.vue?vue&type=template&id=76dca136"
import script from "./AktuellesNew.vue?vue&type=script&lang=js"
export * from "./AktuellesNew.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__